import React, { useState } from 'react';

import * as S from './DraftsTab.styles';
import { Tab } from '../../../components';
import { RespondedTab } from './RespondedTab';
import { PostedTab } from './PostedTab';

export const DraftsTab = () => {
	const [tabs, setTabs] = useState([
		{
			id: 1,
			label: 'Responded',
			component: <RespondedTab />,
		},
		{
			id: 2,
			label: 'Posted',
			component: <PostedTab />,
		},
	]);

	return (
		<S.Wrapper>
			<Tab tabs={tabs} setTabs={setTabs} transparent variation="pill" />
		</S.Wrapper>
	);
};

DraftsTab.propTypes = {};
